var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tiaoliify"}},[_c('section',{staticClass:"w10f8"},[_c('taoliifycont')],1),_c('section',[_c('tiaoifyartic')],1),_c('section',[_c('tiaoifyartic')],1),_c('section',[_c('tiaoifyartic')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }